import { CheckState } from '../../enum/check-state.enum';
import { Selectable } from '../../interface/selectable';
import { CommonUtils } from '../../tool/common-utils';

export class DropdownItem<T extends Selectable> implements Selectable {
  get enable(): boolean {
    return this.item.enable;
  }

  get checkState(): CheckState {
    return this.item.checkState;
  }

  get check(): boolean {
    return this.item.check;
  }

  set check(value: boolean) {
    this.item.check = value;
  }

  public get label(): string {
    return this.item.toString();
  }

  public get icon(): string {
    return this.item.icon;
  }

  public get iconColor(): string {
    return this.item.iconColor;
  }

  public get normalizedText(): string {
    return this.item.normalizedText;
  }

  public preselect: boolean;
  public isGroupHeader: boolean;
  public item: T;
  public items: Selectable[];
  public displayedItems: Selectable[];
  public isDisplayed = true;

  constructor(item: T) {
    this.item = item;
    if (item.items) {
      this.isGroupHeader = true;
      this.items = item.items;
      this.displayedItems = this.items;
    }
  }

  filter(filter: string, onlyCheck?: 'check' | 'uncheck') {
    let str: string;
    if (filter) {
      str = CommonUtils.normalize(filter, true);
      this.isDisplayed = CommonUtils.normalize(this.label, true).includes(str);
    } else {
      this.isDisplayed = true;
    }
    // if is grouped, check if items included search string
    if (this.isGroupHeader) {
      if (!this.isDisplayed) {
        this.displayedItems = this.items.filter(
          (item) =>
            item.normalizedText.includes(str) &&
            (!onlyCheck ||
              (onlyCheck === 'check' && item.check) ||
              (onlyCheck === 'uncheck' && !item.check)),
        );
        this.isDisplayed = this.displayedItems.length > 0;
      } else {
        this.displayedItems = this.items;
      }
    }
  }

  count(): number {
    if (this.isGroupHeader) {
      return this.displayedItems.length;
    } else {
      return 0;
    }
  }

  public compare(item: any) {
    if (item instanceof DropdownItem) {
      return this.item.compare(item.item);
    } else {
      return this.item.compare(item);
    }
  }
}
